import { render, staticRenderFns } from "./CustomerMediaEdit.vue?vue&type=template&id=68f3360f&scoped=true&"
import script from "./CustomerMediaEdit.vue?vue&type=script&lang=babel&"
export * from "./CustomerMediaEdit.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f3360f",
  null
  
)

export default component.exports